exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".schedulecard[data-v-2042ed1f]{background-color:#fff;padding:40px 40px 100px;border-radius:10px}.createForm[data-v-2042ed1f]{margin:0 10px}p[data-v-2042ed1f]{font-size:20px;font-weight:600}.button.is-primary[data-v-2042ed1f]{margin:10px 0 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2042ed1f","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ui/CreateSchedule.vue
// module id = Zp9R
// module chunks = 3